/**
 * @file: description
 * @author:
 * @Date: 2020-03-24 21:16:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-04-20 16:43:48
 */
import React, { useRef } from 'react';
import { IconFont } from '@src/features/common';
import Quill from 'quill';
import { message } from 'antd';
import { APIS } from '@src/services';
import IRange from './types';
import { file2base64, randomStr, maxSize } from './utils';

type Props = ISFCUploadImgProps;

export interface ISFCUploadImgProps {
  quill?: Quill;
}

export function SFCUploadImg(props: Props) {
  const fileInput = useRef<HTMLInputElement>(null);

  const fileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { quill } = props;
    const input = fileInput ? fileInput.current : null;
    if (quill && input) {
      const files = input.files || [];

      Array.from(files).forEach(async item => {
        if (item.size <= maxSize.size) {
          const base64Url = await file2base64(item).then(res => {
            return res;
          });
          const range = quill.getSelection() as IRange | null;
          const index = range ? range.index : quill.getLength();
          const id = randomStr();

          quill.insertEmbed(index, 'img', { src: base64Url, id }, 'user');
          quill.setSelection(index + 1, 1);
          APIS.FileApi.fileBase64UsingPost(base64Url).then(res => {
            const img = document.getElementById(id) as HTMLImageElement | null;

            if (img && res.code === 0 && res.result) {
              img.src = res.result.previewUrl || '';
            }
          });
        } else {
          message.error(maxSize.message);
        }

        input.value = '';
      });
    }
  };

  const tirggerImage = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    props.quill && props.quill.focus();
    fileInput && fileInput.current && fileInput.current.click();
  };

  return (
    <>
      <button className="add-bar--btn" type="button" onClick={tirggerImage}>
        <IconFont type="icon-e-img" />
        <span className="button-item__tip">插入图片</span>
      </button>
      <input
        ref={fileInput}
        type="file"
        accept="image/*"
        className="ql-image hidden"
        onChange={fileChange}
      />
    </>
  );
}

export default SFCUploadImg;
